import {InjectionToken} from '@angular/core';

export const WindowService = new InjectionToken('WindowService');



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/services/window.service.ts